import React from 'react';
import { useSelector } from 'react-redux';
import { selectTitleCheckResponse, selectTitleCheckLoadingState, selectTitleCheckError } from '../../redux-state/selectors';
import { formatDate } from '../utility/formatDate';

function TitleOutputLeftSide() {
  const titleCheckResponse = useSelector(selectTitleCheckResponse);
  const isLoading = useSelector(selectTitleCheckLoadingState);
  const error = useSelector(selectTitleCheckError);

  if (isLoading)
    return <div className="p-6">Loading...</div>;
  if (error)
    return <div className="p-6 text-red-500">Error: {error}</div>;
  if (!titleCheckResponse)
    return <div className="p-6">No data available</div>;

  const { vehicle_info, jsi_info, registration_info, registration_info_extended } = titleCheckResponse;

  return (
    <div className="flex flex-col gap-4 w-[100%]">
      <div className="flex flex-row text-gray-700 font-bold mb-2 items-center h-11">
        Lien & Title Output
      </div>

      <div>
        {vehicle_info && Object.keys(vehicle_info).length > 0 && (
          <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
            <div className="text-gray-700 mb-3 font-bold">
              Vehicle Information
            </div>

            <div className="flex flex-col lg:flex-row w-full gap-6 lg:gap-8">
              <div className="flex flex-col w-full min-w-0 text-gray-700 gap-2">
                {vehicle_info?.vinCode &&
                  <div className="flex flex-row justify-between gap-2 items-start">
                    <div>VIN:</div>
                    <div className="font-medium text-right break-words min-w-0">{vehicle_info?.vinCode}</div>
                  </div>
                }

                {vehicle_info?.year &&
                  <div className="flex flex-row justify-between gap-2 items-start">
                    <div>Year:</div>
                    <div className="font-medium text-right break-words min-w-0">{vehicle_info?.year}</div>
                  </div>
                }

                {vehicle_info?.make &&
                  <div className="flex flex-row justify-between gap-2 items-start">
                    <div>Make:</div>
                    <div className="font-medium text-right break-words min-w-0">{vehicle_info?.make}</div>
                  </div>
                }

                {vehicle_info?.model &&
                  <div className="flex flex-row justify-between gap-2 items-start">
                    <div>Model:</div>
                    <div className="font-medium text-right break-words min-w-0">{vehicle_info?.model}</div>
                  </div>
                }
              </div>
            </div>
          </div>
        )}


        {registration_info && Object.keys(registration_info).length > 0 && (
          <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
            <div className="text-gray-700 mb-3 font-bold">
              Registration Information
            </div>

            <div className="flex flex-col lg:flex-row w-full gap-6 lg:gap-8">
              <div className="flex flex-col w-full min-w-0 text-gray-700 gap-2">
                {registration_info?.plate.plate &&
                  <div className="flex flex-row justify-between gap-2 items-start">
                    <div>Plate Number:</div>
                    <div className="font-medium text-right break-words min-w-0">{registration_info?.plate.plate}</div>
                  </div>
                }

                {registration_info?.issue &&
                  <div className="flex flex-row justify-between gap-2 items-start">
                    <div>Issue Date:</div>
                    <div className="font-medium text-right break-words min-w-0">{registration_info?.issue}</div>
                  </div>
                }

                {registration_info?.status &&
                  <div className="flex flex-row justify-between gap-2 items-start">
                    <div>Status:</div>
                    <div className="font-medium text-right break-words min-w-0">{registration_info?.status}</div>
                  </div>
                }

                {registration_info?.expiry &&
                  <div className="flex flex-row justify-between gap-2 items-start">
                    <div>Expiry date:</div>
                    <div className="font-medium text-right break-words min-w-0">{formatDate(registration_info?.expiry)}</div>
                  </div>
                }
              </div>
            </div>
          </div>
        )}

        {registration_info_extended && registration_info_extended.length > 0 && (
          <div className="bg-white p-6 text-sm mb-6 border border-gray-300 rounded-xl">
          <div className="text-gray-700 mb-3 font-bold">
              Registration Information
            </div>

          {registration_info_extended?.map((report, index) => (
            <div key={index}>
              <div className="flex flex-col lg:flex-row w-full gap-6 lg:gap-8 mb-6 mt-6">
                <div className="flex flex-col w-full min-w-0 text-gray-700 gap-2">
                  {report?.plate &&
                    <div className="flex flex-row justify-between gap-2 items-start">
                      <div>
                        Plate:
                      </div>
                      <div className="font-medium text-right break-words min-w-0">{report?.plate}</div>
                    </div>
                  }

                  {report?.plate_issue_date &&
                    <div className="flex flex-row justify-between gap-2 items-start">
                      <div>
                        Plate Issue Date:
                      </div>
                      <div className="font-medium text-right break-words min-w-0">{formatDate(report?.plate_issue_date)}</div>
                    </div>
                  }

                  {report?.plate_expiry_date &&
                    <div className="flex flex-row justify-between gap-2 items-start">
                      <div>
                        Plate Expiry Date:
                      </div>
                      <div className="font-medium text-right break-words min-w-0">{formatDate(report?.plate_expiry_date)}</div>
                    </div>
                  }

                  {report?.plate_status &&
                    <div className="flex flex-row justify-between gap-2 items-start">
                      <div>
                        Plate Status:
                      </div>
                      <div className="font-medium text-right break-words min-w-0">{report?.plate_status}</div>
                    </div>
                  }

                  {report?.plate_type &&
                    <div className="flex flex-row justify-between gap-2 items-start">
                      <div>
                        Plate Type:
                      </div>
                      <div className="font-medium text-right break-words min-w-0">{report?.plate_type}</div>
                    </div>
                  }

                  {report?.issue_reason &&
                    <div className="flex flex-row justify-between gap-2 items-start">
                      <div>
                        Issue Reason:
                      </div>
                      <div className="font-medium text-right break-words min-w-0">{report?.issue_reason}</div>
                    </div>
                  }

                  {report?.insurance &&
                    <div className="flex flex-row justify-between gap-2 items-start">
                      <div>
                        Insurance:
                      </div>
                      <div className="font-medium text-right break-words min-w-0">{report?.insurance}</div>
                    </div>
                  }
                </div>
              </div>

              {index < registration_info_extended.length - 1 && (
                <div className="border-t-2 border-t-gray-100 mt-4"></div>
              )}
            </div>
          ))}
        </div>
        )}

        

        {jsi_info && jsi_info.length > 0 && (
          <div className="bg-white p-6 text-sm border border-gray-300 rounded-xl">
          <div className="text-gray-700 mb-3 font-bold">
              Junk, Salvage & Insurance Report
            </div>

          {jsi_info?.map((report, index) => (
            <div key={index}>
              <div className="flex flex-col lg:flex-row w-full gap-6 lg:gap-8 mb-6 mt-6">
                <div className="flex flex-col w-full min-w-0 text-gray-700 gap-2">
                  {report?.re_name &&
                    <div className="flex flex-row justify-between gap-2 items-start">
                      <div>
                        Reporting Entity Name:
                      </div>
                      <div className="font-medium text-right break-words min-w-0">{report?.re_name}</div>
                    </div>
                  }

                  {report?.re_category &&
                    <div className="flex flex-row justify-between gap-2 items-start">
                      <div>
                        Reporting Entity Category:
                      </div>
                      <div className="font-medium text-right break-words min-w-0">{report?.re_category}</div>
                    </div>
                  }

                  {report?.disposition_text &&
                    <div className="flex flex-row justify-between gap-2 items-start">
                      <div>
                        Disposition Text:
                      </div>
                      <div className="font-medium text-right break-words min-w-0">{report?.disposition_text}</div>
                    </div>
                  }

                  {report?.record_date &&
                    <div className="flex flex-row justify-between gap-2 items-start">
                      <div>
                        Date Reported:
                      </div>
                      <div className="font-medium text-right break-words min-w-0">{formatDate(report?.record_date)}</div>
                    </div>
                  }
                </div>
              </div>

              {index < jsi_info.length - 1 && (
                <div className="border-t-2 border-t-gray-100 mt-4"></div>
              )}
            </div>
          ))}
        </div>
        )}
      </div>
    </div>
  );
}

export default TitleOutputLeftSide;